export const attachmentResourceType = "attachment" as const;
